// extracted by mini-css-extract-plugin
module.exports = {"appContent":"admin-portal__AppRouting__appContent"};